import { api } from '../api';

interface UserListParams {
  typeFlag?: string;
  tenantId?: string;
  page?: number;
  limit?: number;
  search?: string;

}

export const userService = {
  list: (params?: UserListParams) => api.get('/users', { params }),
  listByRole: (role: string, params?: any) => api.get('/users', { params: { ...params, role } }),
  get: (id: string) => api.get(`/users/${id}`),
  create: (data: any) => api.post('/users/register', data),
  update: (id: string, data: any) => api.put(`/users/${id}`, data),
  remove: (id: string) => api.delete(`/users/${id}`),
  changePassword: (id: string, newPassword: string) =>
    api.put(`/users/${id}/password`, { newPassword }),
};